import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  LightDomStyles,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-media-gallery-caption.css.lit';

/**
 * The Media Gallery Caption component
 * @element outline-media-gallery-caption
 */
@customElement('outline-media-gallery-caption')
export class OutlineMediaGalleryCaption extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  slots = new SlotsController(this);

  /**
   * The variant of the caption
   * @attr variant
   * @type {'inline' | 'stacked'}
   * @default 'stacked'
   **/
  @property({ type: String, reflect: true, attribute: 'variant' })
  variant: 'inline' | 'stacked' = 'stacked';

  render(): TemplateResult {
    return html`
      <div class="media-gallery-caption ${this.variant}">
        ${this.slots.conditionalSlot('heading', false)}
        ${this.querySelector('[slot="description"]') !== null
          ? html` <hr /> `
          : null}
        ${this.slots.conditionalSlot('description', false)}
      </div>
    `;
  }
}
